// extracted by mini-css-extract-plugin
export default {"act":"leftMenu_act__NwKFI","mobileMenu":"leftMenu_mobileMenu__wuC2f","active":"leftMenu_active__3gBy1","logo":"leftMenu_logo__NWew2"};